import { ProsAndCons } from '@ria-client/tw-shared-ui';

export interface CardProsConsProps {
  prosBullets?: string[];
  consBullets?: string[];
}

export function CardProsCons({ prosBullets, consBullets }: CardProsConsProps) {
  return <ProsAndCons consList={consBullets} prosList={prosBullets} />;
}
